/*** IMPORTS FROM imports-loader ***/
var lib = require("whatwg-fetch");

null

/*** EXPORTS FROM exports-loader ***/
module.exports = lib.fetch;



//////////////////
// WEBPACK FOOTER
// ./~/imports-loader?lib=whatwg-fetch!./~/exports-loader?lib.fetch!
// module id = 12
// module chunks = 0